import React from 'react'

const SectionIntro = () => {
  return (
    <section className='bg-principal  flex flex-col w-full'>
      <div className='flex justify-around w-full flex-col-reverse lg:flex-row max-w-screen-2xl mx-auto'>
        <div className="flex w-full lg:w-1/2 justify-center items-center max-w-650  mx-auto lg:pl-24">
          <div className="p-4 lg:p-8 w-full">
            <h1 className="font-tiempo text-azul font-semibold text-4xl text-center lg:text-left lg:text-5xl mb-8">
              Create custom <br />packaging and boxes
            </h1>
            <p className='font-basis font-bold text-gray-1 text-center lg:text-left '>
              Custom packaging and boxes can turn your brand into the total package with full customization, instant quoting, and fast turnarounds.
            </p>
            <div href="#choose-style" className='block '>
              <a href="/"className=' mx-auto lg:mx-0 block p-4 my-8 bg-white w-3/4 rounded-full text-center text-azul font-basis text-gray-1 font-bold font-bold tracking-widest uppercase text-sm'>Choose your packaging style</a>
            </div>
          </div>
        </div>
        <div className="flex w-full lg:w-1/2   justify-center items-center">
          <picture className='img-intro '>
            <img className="" alt="box" src="https://assets.packlane.com/BUOPLPJhijaexYOPF2qvVmy_9uv_6SmzVWrzD3kTUFw/w:1000/fn:homepage-hero/czM6Ly9wYWNrbGFuZS1hc3NldHMvcHJvZHVjdGlvbi9hcHAvaW1hZ2VzL2hvbWVwYWdlLWhlcm8uanBn.jpg" />
          </picture>
        </div>
      </div>
      <div className="w-full px-8 max-w-screen-2xl mx-auto">
        <h3 className='tracking-widest font-basis font-bold text-xs text-gray-1 pb-8 text-center lg:text-left uppercase'>Trusted by over 25,000 brands</h3>
        <ul className="flex justify-around items-center pb-4 hidden lg:flex">
          <li >
            <picture>
              <img alt="Red Bull" src="https://assets.packlane.com/images/redbull.svg" />
            </picture>
          </li>
          <li>
            <picture>
              <img alt="99 Designs" src="https://assets.packlane.com/images/99designs.svg" />
            </picture>
          </li>
          <li>
            <picture>
              <img alt="L'Oreal" src="https://assets.packlane.com/images/loreal.svg" />
            </picture>
          </li>
          <li>
            <picture>
              <img alt="hp" src="https://assets.packlane.com/images/hp.svg" />
            </picture>
          </li>
          <li>
            <picture>
              <img alt="Shopify" src="https://assets.packlane.com/images/shopify.svg" />
            </picture>
          </li>
          <li>
            <picture>
              <img alt="Benefit" src="https://assets.packlane.com/images/benefit.svg" />
            </picture>
          </li>
          <li>
            <picture>
              <img alt="SeatGeek" src="https://assets.packlane.com/images/seatgeek.svg" />
            </picture>
          </li>
          <li>
            <picture>
              <img alt="Google" src="https://assets.packlane.com/images/google.svg" />
            </picture>
          </li>
          <li>
            <picture>
              <img alt="The New York Times" src="https://assets.packlane.com/images/times.svg" />
            </picture>
          </li>
        </ul>
      </div>
    </section>
  )
}

export default SectionIntro
